module.exports = __webpack_public_path__ + "static/fix-main-product-image-carousel-ver4-2-d7b020aa08ff4bea4dd9d2e3da82231b.jpg";